
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/sentry.client.config.ts")
            }
          });